// Kept free of imports: browser code (the scope picker, artifact frames) needs the list without the integration request schemas.

/**
 * External-metrics providers the analytics proxy can serve. Adding a
 * provider here forces (via exhaustiveSwitch) a provider service under
 * apps/bedrock-api/src/services/insights-proxy, plus shared ClickHouse views.
 */
export const INSIGHTS_PROXY_PROVIDERS = [
  "triple-whale",
  "contentsquare",
  "mixpanel",
  "lifetimely",
  "faire",
  "alia",
  "intelligems",
  "meta-marketing-api",
  "roi",
  "shopify",
  "google-analytics",
  "google-search-console",
] as const;
export type InsightsProxyProvider = (typeof INSIGHTS_PROXY_PROVIDERS)[number];
